export const FETCH_CAMPUSES_REQUEST = 'FETCH_CAMPUSES_REQUEST';
export const FETCH_CAMPUSES_SUCCESS = 'FETCH_CAMPUSES_SUCCESS';
export const FETCH_CAMPUSES_FAILURE = 'FETCH_CAMPUSES_FAILURE';
export const RESET_CAMPUSES_FAILURE = 'RESET_CAMPUSES_FAILURE';

export const fetchCampusesRequest = schoolId => ({
  type: FETCH_CAMPUSES_REQUEST,
  schoolId,
});

export const fetchCampusesSuccess = payload => ({
  type: FETCH_CAMPUSES_SUCCESS,
  payload,
});

export const fetchCampusesFailure = error => ({
  type: FETCH_CAMPUSES_FAILURE,
  payload: error,
});

export const resetCampusesFailure = () => ({ type: RESET_CAMPUSES_FAILURE });
